/**
 * `TKey` — the dot-path union of every key in `nb.json` (the master file, principle 8).
 * An unknown key is a *compile* error, not a `missingKey` warning at runtime.
 */
import type { TranslationResource } from './resources';

type Join<K, P> = K extends string
  ? P extends string
    ? P extends ''
      ? K
      : `${K}.${P}`
    : never
  : never;

type Leaves<T> = T extends string ? '' : { [K in keyof T]-?: Join<K, Leaves<T[K]>> }[keyof T];

export type TKey = Leaves<TranslationResource>;

/**
 * The single sanctioned escape hatch for a key assembled at runtime. Every prefix it may
 * produce is registered in `dynamic-keys.ts`, which `check-i18n` reads — so a dynamic key is
 * still covered by the CI gate, just not by the compiler.
 */
export function dynamicKey(key: string): TKey {
  return key as TKey;
}
